import { THEME_TYPE } from '@interfaces';
import { SURVEY_CONFIG } from '@types';
import { appStore } from '@store';

function checkDeviceTheme() {
	const { fsv1m10, fsv1f10 } = appStore.paymentStore.settings;

	if(appStore.params.config === SURVEY_CONFIG.PILATES || appStore.params.config === SURVEY_CONFIG.DEFAULT_CONFIG) {
		return THEME_TYPE.LIGHT;
	}

	if (fsv1m10) {
		return THEME_TYPE.DARK;
	}

	if (fsv1f10) {
		return THEME_TYPE.LIGHT;
	}

	let deviceTheme;

	function isDarkMode() {
		return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
	}

	function isLightMode() {
		return window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
	}

	if (isDarkMode()) {
		deviceTheme = THEME_TYPE.DARK;
	} else if (isLightMode()) {
		deviceTheme = THEME_TYPE.LIGHT;
	} else {
		deviceTheme = THEME_TYPE.LIGHT;
	}

	return deviceTheme;
}

export default checkDeviceTheme;
